import commonHelper from '@/app/utility/common.helper.utility';
import URL_UTILITY from '../../../utility/url.utility';
import previewDoc from '../../onlineApproval/internalWorkFlow/history/uploadDocument/previewDoc';
import appStrings from '@/app/utility/string.utility';
import bankUpdateDetails from './bankUpdateDetails';
import HistoryRecord from '@/app/components/onlineApproval/internalWorkFlow/history/historyRecord';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';
export default {
  name: 'Bank Update',
  components: { previewDoc, bankUpdateDetails, HistoryRecord, ApprovalHistory,},
  props: [
    'partyRowDetails',
    'urlSummaryData',
    'workflowId',
    'dashboardDetails',
  ],
  watch: {
    currentPage: function() {
      this.getVendorBankDetails();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getVendorBankDetails();
    }
  },
  data() {
    return {
      totalRows: null,
      currentPage: 1,
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOptionSelectedInvoice(),
      isSuccess: false,
      responseMsg: '',
      showAlert: false,
      updateBankData: [],
      updateBankFields: [
        {
          key:'vendor_code'
        },
        {
            key:'name',
            label:'Vendor Name'
        },
        {
          key: 'bank_code',
          label: 'Bank Name'
        },
        {
          key: 'branch_name'
        },
        {
          key: 'account_num',
          label: 'Account No'
        },
        {
          key:'active',
          label:'Bank Status'
        },
        {
          key:'end_date'
        },
        // {
        //   key: 'ifsc',
        //   label: 'IFSC'
        // },
        // {
        //   key: 'beneficiary_name'
        // },
        {
          key:'approval_status',
          label:'Status'
        },
        // {
        //   key:'vendor_site_code',
        //   label:'Site Name'
        // }
      ],
      partyReqId: null,
      wfDtlId: null,
      eventId: null,
      approvalStatus: null,
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      uploadedFileName: null,
      showOpenModal: false,
      docDtlId: null,
      authToken: null,
      openKmAuth: null,
      tempToken: null,
      dynamicData:null,
      currentPageIndex:null,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false,
        newTab: true,
      },
      bankDocumentsModal:false,
      partyBankReqId:null,
      vendorName:null,
      accountNumber:null,
      appStatus: { value: 'INPROCESS', text: 'INPROCESS' },
      showValueSetModal: false,
      bankName:null,
      rackRowData:null,
      showHideBankUpdateModalFlag:false,
      vendorCode:null,
      showHistoryBtn: false,
      showHistory: false,
      historyType: null,
      recordId: null,
    };
  },
  mounted() {
    // this.getVendorBankDetails();
  },
  methods: {
    getVendorBankDetails() {
        const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,   
        party_name: this.vendorName,
        approval_status: this.appStatus.value,
        account_num:this.accountNumber,
        bank_code:this.bankName,
        vendor_code:this.vendorCode,
        // int_contact_name: this.internalContact.text,
        // start_date: this.fromDate,
        // end_date: this.toDate       
        };
        this.loader = true;
        this.$store
          .dispatch('vendorUpdate/getVendorBankUpdateData', payload)
          .then(resp => {
            this.loader = false;
            if (resp.status === 200) {
              this.updateBankData = resp.data.data.page;
              this.totalRows = resp.data.data.total_elements;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      },
      openValueSetModal(vsetCode) {
        this.vsetCode = vsetCode;
        this.showValueSetModal = true;
        this.setTimeVsetCode = setTimeout(() => {
          const vSetData = {
            valueSetName: vsetCode,
            multiFlag: null
          };
          this.eventBus.$emit('valueSetCode', vSetData);
        }, 0);
      },
      closeValueSetModal() {
        this.showValueSetModal = false;
      },
      selectedvalueSet(item) {
        if (
          this.vsetCode === appStrings.VALUESETTYPE.PARTY_REQ_APPROVAL_STATUS_VSET
        ) {
          this.appStatus = {
            text: item.value_meaning,
            value: item.value_code
          };
        } 
        // else if (this.vsetCode === appStrings.VALUESETTYPE.Select_Employee) {
        //   this.internalContact.text = item.value_code;
        //   this.internalContact.value = item.value_set_dtl_id;
        // }
      },
      clearFilters() {
        this.vendorName = null;
        this.accountNumber = null;
        this.vendorCode=null;
        this.appStatus = { value: 'INPROCESS', text: 'INPROCESS' };
        this.bankName=null,
        this.updateBankData = [];
        this.totalRows = null;
        this.currentPage = 1;
      },
      rowSelected(item) {
        this.rackRowData = item;
        this.showHideBankUpdateModal(true);
      },
      showHideBankUpdateModal(flag){
        this.showHideBankUpdateModalFlag=flag
      },
      showHideHistory(flag, historyType, type) {
        this.showHistory = flag;
        this.historyType = historyType;
        if (type == 'dropdown') {
          this.recordId = this.rackRowData.party_bank_req_update_id;
        }
      },
    // tempFunction() {
    //   const token = commonHelper.getOpenKmAuthToken();
    //   token.then(key => {
    //     if (key) alert('Hi.!!');
    //   });
    // },
    // openPreviewDoc(flag, fileName, index, data) {
    //   const filterDynamicData = data.filter((a) => a.original_file_name);
    //   const getFileName = data[index].original_file_name;
    //   for (let i = 0; i < filterDynamicData.length; i++) {
    //     if (filterDynamicData[i].original_file_name == getFileName) {
    //       this.currentPageIndex = i + 1;
    //       break;
    //     }
    //   }
    //   this.dynamicData = filterDynamicData;
    //   if (flag) {
    //     this.getOpenKmAuthTokenPreview(flag, fileName);
    //     // this.timeout = setTimeout(() => {
    //     //   // this.showHideOpenModal(flag, docDtlId, this.openKmAuth, fileName); // previous function
    //     //   this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
    //     // }, 1000);
    //   }
    // },
    // partOnboardingPreview(flag, docDtlId, authToken, fileName) {
    //   if (flag) {
    //     this.fileExtension = commonHelper.getFileExtension(fileName);
    //   }
    //   if (this.fileExtension === 'xlsx') {
    //     alert('Not Allowed');
    //   } else {
    //     // this.showOpenModal = flag;
    //     this.docDtlId = docDtlId;
    //     this.authToken = authToken;
    //     this.uploadedFileName = fileName;
    //     this.previewOpenDoc();    
    //   }     
    // },
    // previewOpenDoc() {
    //   this.fileExtension = commonHelper.getFileExtension(this.uploadedFileName);
    //   const payload = {
    //     docDetailId: this.docDtlId,
    //     token: this.authToken,
    //     fileExtension: this.fileExtension
    //   };
    //   this.loader = true;
    //   commonHelper.previewImgDocParty(payload);
    //    this.loader =false
    // },
    // showHideOpenModal(flag, authToken, fileName) {
    //   if (flag) {
    //     this.fileExtension = commonHelper.getFileExtension(fileName);
    //   }
    //   if (this.fileExtension === 'xlsx') {
    //     alert('Not Allowed');
    //   } else {
    //     this.showOpenModal = flag;
    //     this.docDtlId = this.docDetlsId;
    //     this.authToken = authToken;
    //     this.uploadedFileName = fileName;
    //   }
    // },
    // getOpenKmAuthTokenPreview(flag, fileName) {
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
    //     .then(response => {
    //       this.loader = false;
    //       if (response.status === 200) {
    //         this.openKmAuth = response.data.data.token;
    //         if(this.openKmAuth){
    //           // this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
    //           this.showHideOpenModal(flag, this.openKmAuth, fileName)
    //         }
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    // getOpenKmAuthToken(fileName) {
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
    //     .then(response => {
    //       this.loader = false;
    //       if (response.status === 200) {
    //         this.openKmAuth = response.data.data.token;
    //         const url =
    //           this.downloadDocUrl +
    //           '/download/' +
    //           this.docDetlsId +
    //           '?token=' +
    //           this.openKmAuth;
    //         commonHelper.downloadFile(url, fileName);
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    // viewBankDocuments(flag, item) {
    //   if(flag){
    //     this.partyBankReqId = item.party_bank_req_id;
    //     this.docDetlsId=item.document_det_id
    //     this.getBankDocumentsData();
    //   }
    //   this.bankDocumentsModal = flag
    // },
    // getBankDocumentsData(){
    //   const payload = {
    //     menu_id: 374,
    //     sub_menu_id: 80,
    //     record_id: this.partyBankReqId,
    //     // user_id: this.userId,
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch("intWorkflow/getOpenKmDocDtl", payload)
    //     .then((resp) => {
    //       this.loader = false;
    //       if (resp.status === 200) {
    //         this.bankDocumentsData = resp.data.data.page;
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  }
};
